<template>
  <div id="filter-vessel-type">
    <div>
      <vs-row vs-type="flex" class="mt-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="6"
        >
          <span class="aisea-text-16-400-white">全て</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="allSwitch"/>
        </vs-col>
      </vs-row>

      <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/TankerInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">タンカー船</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="tankerSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/CargoInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">貨物船</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="cargoSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/TugInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">タグボート</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="tugSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/PassengerInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">旅客船</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="cruiseSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/FishingInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">漁船</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="fishingSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/PleasureBoatInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">プレジャーボート</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="pleasureSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/BikeInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">ジェットスキー</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="jetSkiSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/WorkInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">作業船</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="workSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/SailboatInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">ヨット</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="sailBoatSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/BargeInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <span class="aisea-text-16-400-white ml-5">バージ</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="bargeSwitch"/>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-vessel-img" src="@/assets/images/icons/vessels/OtherInactive.png">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">その他</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="otherSwitch"/>
        </vs-col>
      </vs-row>

    </div>
  </div>
</template>

<script>
import {VesselMixin, ColorMixin} from "@/mixins";
import {createNamespacedHelpers} from "vuex";
import _ from "lodash";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";

// Store
const {mapActions: mapActionsOfLiveMap} = createNamespacedHelpers("liveMap");

export default {
  name: "VesselDisplaySetting",
  mixins: [VesselMixin, ColorMixin],
  data() {
    return {
      isAllSwitchOnEvent: false,
      isAllFilterOffEvent: false,
      localFilterVessels: [],
      allSwitch: false,
      tankerSwitch: false,
      cargoSwitch: false,
      tugSwitch: false,
      cruiseSwitch: false,
      fishingSwitch: false,
      pleasureSwitch: false,
      jetSkiSwitch: false,
      workSwitch: false,
      sailBoatSwitch: false,
      bargeSwitch: false,
      otherSwitch: false,
    };
  },
  watch: {
    localFilterVessels(val) {
      this._setFilterVessels(this, val)
    },
    async allSwitch(isOn) {
      if (isOn) {
        if (!this.isAllSwitchOnEvent) {
          await this.setAllFilter(true)
          let filterVessels = this.getVesselCategoryIds();
          this.localFilterVessels = filterVessels;
        } else {
          this.isAllSwitchOnEvent = false
        }
      } else {
        this.localFilterVessels = [];
        this.isAllFilterOffEvent = true
        await this.setAllFilter(false)
        this.isAllFilterOffEvent = false
      }
    },
    tankerSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.TANKER))
    },
    cargoSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.CARGO))
    },
    tugSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.TUGBOAT))
    },
    cruiseSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.CRUISE))
    },
    fishingSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.FISHING))
    },
    pleasureSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.PLEASURE))
    },
    jetSkiSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.JET_SKI))
    },
    workSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.WORK))
    },
    sailBoatSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.SAILBOAT))
    },
    bargeSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.BARGE))
    },
    otherSwitch(isOn) {
      this.setFilterState(isOn, String(this.vesselCategory.OTHER))
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["setFilterVessels"]),
    _setFilterVessels: _.debounce((self, val) => {
      let filterVessels = _.cloneDeep(val)
      FireStoreService.saveFilterVessels(filterVessels)
      LocalDbService.saveFilterVessels(filterVessels);
      self.setFilterVessels(filterVessels);
    }, 1000),
    setFilterState(isOn, vesselCategory) {
      if (this.isAllFilterOffEvent) return
      if (isOn) {
        this.localFilterVessels.push(vesselCategory)
      } else {
        this.filterVessel(vesselCategory)
      }
      if (this.localFilterVessels.length === 0) {
        this.allSwitch = false
      }
      if (this.getVesselCategoryIds().length === this.localFilterVessels.length) {
        this.allSwitch = true
      }
    },
    filterVessel(id) {
      this.localFilterVessels = this.localFilterVessels.filter(v => {
        return v !== id
      })
    },
    async setAllFilter(val) {
      this.tankerSwitch = val;
      this.cargoSwitch = val;
      this.tugSwitch = val;
      this.cruiseSwitch = val;
      this.fishingSwitch = val;
      this.pleasureSwitch = val;
      this.jetSkiSwitch = val;
      this.workSwitch = val;
      this.sailBoatSwitch = val;
      this.bargeSwitch = val;
      this.otherSwitch = val;
    },
    async setFilterSwitch(filterVessels) {
      filterVessels.forEach(type => {
        switch (Number(type)) {
          case this.vesselCategory.TANKER :
            this.tankerSwitch = true;
            break;
          case this.vesselCategory.CARGO :
            this.cargoSwitch = true;
            break;
          case this.vesselCategory.TUGBOAT:
            this.tugSwitch = true;
            break;
          case this.vesselCategory.CRUISE:
            this.cruiseSwitch = true;
            break;
          case this.vesselCategory.FISHING:
            this.fishingSwitch = true;
            break;
          case this.vesselCategory.PLEASURE:
            this.pleasureSwitch = true;
            break;
          case this.vesselCategory.JET_SKI:
            this.jetSkiSwitch = true;
            break;
          case this.vesselCategory.WORK:
            this.workSwitch = true;
            break;
          case this.vesselCategory.SAILBOAT:
            this.sailBoatSwitch = true;
            break;
          case this.vesselCategory.BARGE:
            this.bargeSwitch = true;
            break;
          case this.vesselCategory.OTHER:
            this.otherSwitch = true;
            break;
        }
      })
    },
  },
  async created() {
    let filterVessels = await LocalDbService.getFilteredVessels();
    if (filterVessels.length === 0) {
      this.allSwitch = false;
      await this.setAllFilter(false)
      this.localFilterVessels = filterVessels;
    } else {
      await this.setFilterSwitch(filterVessels)
      this.localFilterVessels = filterVessels;
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#filter-vessel-type {
  background: $aisea-blue-gray;

  .filter-vessel-img {
    height: 25px;
    width: 12px;
  }
}
</style>
